module.exports = __webpack_public_path__ + "img/Logo-BRANCA.84c82988.svg";